import { TranslateLoader, Translation } from '@ngx-translate/core';
import { CURRENT_LANGUAGE } from '@shared/services/language';
import * as translations from 'public/i18n';
import { Observable, of } from 'rxjs';

const typedTranslations: Record<string, Translation> = translations as unknown as Record<string, Translation>;

export class CustomTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<Translation> {
    const language = lang.replace('-', '_');
    return of(typedTranslations[language] ?? typedTranslations[CURRENT_LANGUAGE()] ?? {});
  }
}
